/**
 * Debug logging gate for the widget bundles.
 *
 * Infra chatter (config/preload/session/WS plumbing) must not reach customer
 * consoles — but stays one flag away for support sessions:
 *   localStorage.setItem("bhai_debug", "1")   (or load with ?bh_debug=1)
 *
 * The voice/STT "semi-debug" lines ([BlueHat voice] / [BlueHat stt]) are
 * deliberately NOT gated — they're the field diagnostics that let a bench
 * report say exactly what the pipeline heard (owner call, 2026-07-22).
 */

const enabled: boolean = (() => {
  try {
    if (typeof location !== "undefined" && /[?&]bh_debug=1\b/.test(location.search)) {
      return true;
    }
    return typeof localStorage !== "undefined" && localStorage.getItem("bhai_debug") === "1";
  } catch {
    return false; // storage blocked (e.g. some private modes) → quiet
  }
})();

export function bhDebugEnabled(): boolean {
  return enabled;
}

export function debugLog(...args: unknown[]): void {
  if (!enabled) return;
  try {
    console.log(...args);
  } catch {
    /* ignore */
  }
}
